import React, { useEffect, useState } from "react";
import { useTheme } from "styled-components";

import { League } from "../../models/Leagues";
import { Cast } from "../../models/Cast";
import apiRoutes from "../../services/apiRoutes";
import useApi from "../../hooks/useApi";
import { Show } from "../../models/Shows";
import { LeagueChallengeQuestions } from "../../models/ChallengeQuestions";

import { CastAnswer } from "./AnswerChallengeQuestions";
import AnswerQuestionOption from "../molecules/AnswerQuestionOption";

interface AnswerQuestionOptionListProps {
    question: LeagueChallengeQuestions;
    league?: League;
    show: Show;
    answer?: CastAnswer;
    disabled?: boolean;
    onSelect: (player: Cast) => void;
}

const AnswerQuestionOptionList: React.FC<AnswerQuestionOptionListProps> = ({
    league,
    answer,
    disabled,
    onSelect,
    show,
    question,
}) => {
    const theme = useTheme();
    const [players, setPlayers] = useState<Cast[]>();

    const castRequest = useApi(
        apiRoutes.GET_QUESTION_CAST(show.id, question.question_id),
        {
            responseKey: "cast",
            onSuccess: (response: Cast[]) => {
                if (response.length > 0) {
                    setPlayers(response);
                } else {
                    setPlayers([]);
                }
            },
        }
    );

    useEffect(() => {
        castRequest.request({
            leagueId: league?.id,
            episode: show.current_episode,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [league, show]);

    return (
        <div className="ml-2 mr-2">
            <span style={{ fontSize: 15, color: theme.textColor }}>
                Select a player:
            </span>
            {players?.map((player) => (
                <AnswerQuestionOption
                    key={player.id}
                    league={league}
                    player={player}
                    answer={answer}
                    disabled={disabled}
                    onSelect={() => onSelect(player)}
                />
            ))}
        </div>
    );
};

export default AnswerQuestionOptionList;
